import store from '@/store'

import TextInfo from '@/components/datainfo/TextInfo'
import TypeItem from '@/components/datainfo/TypeItem'

import {
  restartTypeList
} from './restart_type'

import {
  appServiceConfigRequest
} from '@/api'

export const appServiceConfigList = function (parm = {}) {
  let config = {
    key: parm.key || 'app_service_config',
    titleConfig: {
      // getNoTitle: (dataList) => {
      //   return dataList.length === 0
      // },
      title: parm && parm.title ? parm.title : '部署配置',
      getTitleMenus: () => {
        let data = []
        if (parm && parm.titleMenus) {
          data = parm.titleMenus
        } else {
          data = [{
            key: 'add',
            label: '新增'
          }]
        }
        return data
      }
    },
    listConfig: {
      getListMenus: () => {
        let data = [{
          key: 'edit',
          label: '修改'
        },
        {
          key: 'del',
          label: '删除'
        }]
        if (parm && parm.listMenus) {
          data = parm.listMenus
        }
        return data
      },
      config: appServiceConfig(parm.childParm || {}),
      getTitle: (data) => {
        return data.restartTypeName
      }
    },
    getHisData (dataParm) {
      return {
        appServiceId: dataParm.appServiceId
      }
    },
    async getData (dataParm) { 
      if (!dataParm.appServiceId && !dataParm.id) {
        return Promise.resolve([])
      }
      return await appServiceConfigRequest.get(dataParm)
    },
    updateConfig: {
      title: '部署配置',
      request: appServiceConfigRequest,
      getFormParms () {
        return [{
          type: 'textarea',
          label: '存放路径',
          key: 'uploadPkgPath'
        },
        {
          type: 'textarea',
          label: '存放文件名',
          key: 'uploadPkgName'
        },
        {
          type: 'select',
          label: '启停类型',
          key: 'restartTypeId',
          selectDatas: store.getters.restartTypeList,
          check: {
            required: true
          }
        },
        {
          type: 'textarea',
          label: '配置',
          key: 'config'
        },
        {
          type: 'input',
          label: '启动超时',
          key: 'startTimeout'
        },
        {
          type: 'input',
          label: '停止超时',
          key: 'stopTimeout'
        },
        {
          type: 'input',
          label: '默认超时',
          key: 'timeout'
        }]
      }
    }
  }
  return config
}

export const appServiceConfig = function ({defaultOpen, showCheckbox}) {
  let config = {
    showCheckbox: showCheckbox || false,
    defaultOpen: defaultOpen || false,
    getInfoParm: (data) => {
      return [{
        comp: TextInfo,
        config: {
          infoParm: [{
            label: '存放路径',
            field: 'uploadPkgPath'
          },
          {
            label: '存放文件名',
            field: 'uploadPkgName'
          },
          {
            label: '启停类型',
            field: 'restartTypeName'
          },
          {
            label: '配置',
            field: 'config'
          },
          {
            label: '启动超时',
            field: 'startTimeout'
          },
          {
            label: '停止超时',
            field: 'stopTimeout'
          },
          {
            label: '默认超时',
            field: 'timeout'
          }]
        }
      },
      {
        comp: TypeItem,
        dataParm: {
          id: data.restartTypeId
        },
        config: restartTypeList({titleMenus: [], listMenus: []})
      }]
    }
  }
  return config
}
